import React from 'react'
import { curriculoData } from '../../data'
import H2 from '../H2'
import SkillBlock from '../SkillBlock'
import * as C from './styles'

const Skills = () => {

  return (
    <C.Skills>
        <H2 title='curriculum' />
        <C.SkillsContent>
            <C.SkillsList>
                <SkillBlock skillGroup={curriculoData.profissional.group} skills={curriculoData.profissional.profissional} />            
                <SkillBlock skillGroup={curriculoData.certificados.group} skills={curriculoData.certificados.certificados} />
                <SkillBlock skillGroup={curriculoData.educacional.group} skills={curriculoData.educacional.educacional} />
                <SkillBlock skillGroup={curriculoData.linguas.group} skills={curriculoData.linguas.linguas} />
            </C.SkillsList>
        </C.SkillsContent>
    </C.Skills>
  )
}

export default Skills